/**
 * @module experience/credit-check
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

export const BILLING_PAYMENT_CONSTANTS = {
  PAYMENT_METHOD_NAME: 'storedPayments',
  METHOD_TYPE: 'regular',
  FULL_NAME: 'fullName',
  CVV: 'cvv',
  CARDNUMBER: 'cardNumber',
  EXPIRATION_YEAR: 'expirationYear',
  EXPIRATION_MONTH: 'expirationMonthName',
  ZIP_CODE: 'zipCode',
  TEMP_TOKEN: 'TemporaryToken',
  SIX: 6,
  RADIX_VALUE_TEN: 10,
  TWO: 2,
  TRANSACTION_TYPE: 'ACTIVATION',
  CHECKED: 'checked',
  PAPER: 'paper',
  ELECTRONIC: 'electronic',
  SUMMARY: 'summary',
  DETAIL: 'detail',
  PAPERLESS_BILL: 'PAPERLESS_BILL',
  DETAIL_BILL_VALUE: '$0',
  POSTPAID: 'POSTPAID',
  ENGLISH: 'ENGLISH',
  ENGLISH_SHORTNAME: 'en',
  SPANISH_SHORTNAME: 'es',
  MANAGE_PROFILE_MODULE: 'ManageProfileModule',
  EDIT_ACTION: 'EDIT',
  REMOVE_ACTION: 'REMOVE',
  ADD_ACTION: 'ADD',
  NEW_CREDIT_DEBIT_CARD: 'newCreditDebitCard',
  AUTOPAY: 'autopay',
  HYBRID_CARD: 'Hybrid',
  CREDIT_CARD: 'Credit',
};
